import { keyframes } from "@emotion/react";

/** Gentle vertical entrance for hero copy and cards */
export const contentReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/** Slow pan/zoom on hero imagery (contained by overflow) */
export const kenBurnsSoft = keyframes`
  0% {
    transform: scale(1) translate(0, 0);
  }
  100% {
    transform: scale(1.07) translate(-1.5%, -1%);
  }
`;

/** Floating orbs behind hero */
export const blobDriftA = keyframes`
  0%, 100% {
    transform: translate(0, 0) rotate(12deg) scale(1);
  }
  50% {
    transform: translate(-18px, 14px) rotate(8deg) scale(1.04);
  }
`;

export const blobDriftB = keyframes`
  0%, 100% {
    transform: translate(0, 0) rotate(0deg) scale(1);
  }
  50% {
    transform: translate(14px, -18px) rotate(-4deg) scale(1.05);
  }
`;

/** Soft pulse on mesh / gradient overlays */
export const meshGlow = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.88;
  }
`;
